'use strict';

const { windowLoaded } = require('@grpn/document-states');
const contextmenu = require('../../ugc_photos/frontend/contextmenu.js');

const CarouselV2Initial = {
  init() {
    windowLoaded.then(() => {
      contextmenu.disabled('#ugc-photos, #ugc-photos-modal');

      const imageElement = document.querySelector(
        '#carousel.carousel-v2 .media-container img'
      );

      if (!imageElement) {
        return;
      }

      const { media, states } = window.storePayload.carouselV2;

      if (!media || !states) {
        return;
      }

      const { imagesMap, imagesList } = media;
      const imageData = imagesMap[imagesList[0]];

      imageElement.src = imageData.mainUrl;

      states.blurLoaded.push(imagesList[0]);
      states.loaded.push(imagesList[0]);
    });
  },
};

module.exports = CarouselV2Initial;
